import { Divider, Stack, Typography } from '@mui/material';
import theme from '../../theme';

const AlbumCountWithDate = ({ albumCount, date, withDate = true, type = 'ALBUM', sx = {} }) => {
  const label =
    type === 'TRACK' ? '곡' : '앨범';

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={sx}>
      <Typography
        fontSize={{ xs: 13, lg: 14 }}
        fontWeight="regular"
        sx={{ color: theme.palette.black[4], whiteSpace: 'nowrap' }}
      >
        {albumCount} {label}
      </Typography>
      {withDate && date && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ height: '8px', alignSelf: 'center', backgroundColor: theme.palette.grey.line }}
          />
          <Typography
            fontSize={{ xs: 13, lg: 14 }}
            fontWeight="regular"
            sx={{ color: theme.palette.black[4], whiteSpace: 'nowrap' }}
          >
            {date}
          </Typography>
        </>
      )}
    </Stack>
  );
};

export default AlbumCountWithDate;
